export enum ELoginStatus {
  'OK' = 'ok',
  'ERROR' = 'error',
}
